<!-- O título saiu daqui quando a listagem virou conteúdo de aba: quem nomeia a seção agora
     é o label da mat-tab em supplier-portal-home. -->
<div class="mt-4">
  <mat-card class="card-style">
    @if (!loading) {
      <div>
        <table-list-supplier-portal-os
          [dataSource]="itemsList"
          [columns]="columns"
          (viewItem)="viewItem($event)"
        />
        @if (itemsList.length > 0) {
          <mat-paginator
            [length]="numberRows"
            [pageSize]="rows"
            [pageIndex]="page - 1"
            [pageSizeOptions]="[5, 10, 20, 30]"
            (page)="onPageEvent($event)"
          >
          </mat-paginator>
        }
      </div>
    } @else {
      <div>
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </div>
    }
  </mat-card>
</div>
